<script context="module" lang="ts">
    export const MODAL_ID = 'ck-container';
</script>

<div id={MODAL_ID} />

<style lang="scss">
    :global(#ck-container) {
        background-color: transparent;
        border-width: 0;
        z-index: var(--z-modal);

        // This is needed to make the iframe's overlay transparent.
        // This is a known issue in CommerceKit
        // rdar://110857330 (CK: add CSS color-scheme:light to iframe)
        :global(iframe) {
            color-scheme: normal;
        }
    }
</style>
